import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import Backend from 'i18next-http-backend';
import enTranslation from './locales/en/translation.json'
import ukTranslation from './locales/uk/translation.json'
import thTranslation from './locales/th/translation.json'
import idTranslation from './locales/id/translation.json'
import hiTranslation from './locales/hi/translation.json'
import arTranslation from './locales/ar/translation.json'
import viTranslation from './locales/vi/translation.json'

if (i18next.isInitialized) {
    // Добавляем или обновляем переводы для текущего языка
    i18next.addResourceBundle('en', 'translation', enTranslation, true, true);
    i18next.addResourceBundle('uk', 'translation', ukTranslation, true, true);
    i18next.addResourceBundle('th', 'translation', thTranslation, true, true);
    i18next.addResourceBundle('id', 'translation', idTranslation, true, true);
    i18next.addResourceBundle('hi', 'translation', hiTranslation, true, true);
    i18next.addResourceBundle('ar', 'translation', arTranslation, true, true);
    i18next.addResourceBundle('vi', 'translation', viTranslation, true, true);
} else {
    i18next
        .use(initReactI18next)
        .use(Backend)
        .init({
            resources: {
                en: {translation: enTranslation},
                uk: {translation: ukTranslation},
                th: {translation: thTranslation},
                id: {translation: idTranslation},
                hi: {translation: hiTranslation},
                ar: {translation: arTranslation},
                vi: {translation: viTranslation},
                // ...add other languages
            },
            fallbackLng: 'en',

        })
}